import { useState } from "react";
import endpointPayApi from "./AxiosSettingsApi";

const useSettings = ({ api, method }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const reset = () => {
    setData(null);
    setLoading(false);
  };

  const onCall = async ({ data, headers, params }) => {
    setLoading(true);
    try {
      let result;
      if (method === "get")
        result = await endpointPayApi[method](api, { headers, params });
      else
        result = await endpointPayApi[method](api, data, { headers, params });
      setLoading(false);
      setData(result.data);
      return Promise.resolve(result.data);
    } catch (err) {
      setLoading(false);
      setData(err);
      return Promise.reject(err);
    }
  };

  return {
    loading,
    data,
    reset,
    onCall,
  };
};

export default useSettings;
